import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Levering',
  [ORDER_METHODS.pickup]: 'Afhentning',
  [ORDER_METHODS.room_service]: 'Roomservice',
};
